export default __webpack_public_path__ + "static/LeftPhone4X-e2221d150a456c757960865f850df274.webp";